<template>
    <div class="py-4 container-fluid">
      <div class="row">
        <div class="col-lg-12">
          <div class="row">
            <div class="col-lg-4 col-md-6 col-12">
              <card
                :title="stats.money.title"
                :value="constracts.length"
                :percentage="stats.money.percentage"
                :iconClass="stats.money.iconClass"
                :iconBackground="stats.money.iconBackground"
                :detail="stats.money.detail"
                directionReverse
                @click="goTo('contracts')"
              ></card>
            </div>
            <div class="col-lg-4 col-md-6 col-12">
              <card
                :title="stats.users.title"
                :value="installs.length"
                :percentage="stats.users.percentage"
                :iconClass="stats.users.iconClass"
                :iconBackground="stats.users.iconBackground"
                :detail="stats.users.detail"
                directionReverse
                @click="goTo('installs')"
              ></card>
            </div>
            <div class="col-lg-4 col-md-6 col-12">
              <card
                :title="stats.clients.title"
                :value="installsP.length"
                :percentage="stats.clients.percentage"
                :iconClass="stats.clients.iconClass"
                :iconBackground="stats.clients.iconBackground"
                :percentageColor="stats.clients.percentageColor"
                :detail="stats.clients.detail"
                directionReverse
                @click="goTo('noinstalls')"
              ></card>
            </div>
            <!-- <div class="col-lg-3 col-md-6 col-12">
              <card
                :title="stats.sales.title"
                :value="stats.sales.value"
                :percentage="stats.sales.percentage"
                :iconClass="stats.sales.iconClass"
                :iconBackground="stats.sales.iconBackground"
                :detail="stats.sales.detail"
                directionReverse
              ></card>
            </div> -->
          </div>
          <div class="row">
            <div class="col-lg-7 mb-lg">
              <!-- line chart -->
              <div class="card z-index-2">
                <gradient-line-chart title="Contratos por marcas" detail1="" :dataChart="dataChart" v-if="!isLoading"/>
              </div>
            </div>
            <div class="col-lg-5">
              <carousel />
            </div>
          </div>
          <!-- <div class="row mt-4">
            <div class="col-lg-12 mb-lg-0 mb-4">
              <div class="card">
                <div class="p-3 pb-0 card-header">
                  <div class="d-flex justify-content-between">
                    <h6 class="mb-2">Contratos</h6>
                  </div>
                </div>
                <div class="table-responsive">
                  <table class="table align-items-center">
                    <tbody>
                      <Loading v-if="isLoading"/>
                      <tr v-for="(contract, index) in constracts" :key="index">
                        <td class="w-30">
                          <div class="px-2 py-1 d-flex align-items-center">
                            <div class="ms-4">
                              <p class="mb-0 text-xs font-weight-bold">Numero:</p>
                              <h6 class="mb-0 text-sm"><a :href="'/contract/'+contract._id">{{ contract.Name }}</a></h6>
                            </div>
                          </div>
                        </td>
                        <td>
                          <div class="text-center">
                            <p class="mb-0 text-xs font-weight-bold">Cliente:</p>
                            <h6 class="mb-0 text-sm" v-if="contract.Cliente__c !=null">{{ contract.Cliente__c.Name }}</h6>
                          </div>
                        </td>
                        <td>
                          <div class="text-center">
                            <p class="mb-0 text-xs font-weight-bold">Agencia:</p>
                            <h6 class="mb-0 text-sm" v-if="contract.Agencia__c !=null">{{ contract.Agencia__c.Name }}</h6>
                          </div>
                        </td>
                        <td class="text-sm align-middle">
                          <div class="text-center col">
                            <p class="mb-0 text-xs font-weight-bold">Estado:</p>
                            <h6 class="mb-0 text-sm">{{ contract.EstadoDeCampana__c }}</h6>
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
            <div class="col-lg-5">
              <categories-card />
            </div> 
          </div> -->
        </div>
      </div>
    </div>
  </template>
  <script>
  //import Loading from '@/examples/Loading.vue';
  import Card from "@/examples/Cards/Card.vue";
  import GradientLineChart from "@/examples/Charts/GradientLineChart.vue";
  import Carousel from "./components/Carousel.vue";
  //import CategoriesCard from "./components/CategoriesCard.vue";
  
  export default {
    name: "dashboard-default",
    data() {
      return {
        stats: {
          money: {
            title: "Contratos",
            value: "0",
            percentage: "",
            iconClass: "ni ni-paper-diploma",
            detail: "",
            iconBackground: "bg-gradient-primary",
          },
          users: {
            title: "Medios Instalados",
            value: "0",
            percentage: "",
            iconClass: "ni ni-settings",
            iconBackground: "bg-gradient-danger",
            detail: "",
          },
          clients: {
            title: "Medios Pendientes de instalar",
            value: "0",
            percentage: "",
            iconClass: "fa fa-remove",
            percentageColor: "text-danger",
            iconBackground: "bg-gradient-success",
            detail: "",
          },
          sales: {
            title: "Casos abiertos",
            value: "0",
            percentage: "",
            iconClass: "ni ni-notification-70",
            iconBackground: "bg-gradient-warning",
            detail: "",
          },
        },
        constracts:[],
        installs: [],
        installsP:[],
        dataChart:[],
      };
    },
    components: {
      //Loading,
      Card,
      GradientLineChart,
      Carousel,
      //CategoriesCard,
     
    },
    methods:{
      fetchContracts(){
        this.isLoading=true;
        let id=localStorage.getItem('AccountId'); 
        fetch(this.$EndPoint+'campanas/get_by_owner/'+id)
        .then(response=>response.json())
        .then(result=>{
          console.log(result);
          this.constracts=result;
          const countByMarca = {};
          result.forEach(row => {
            const marca = row.Marca__c.Name;
            if (!countByMarca[marca]) {
              countByMarca[marca] = 1;
            } else {
              countByMarca[marca]++;
            }

          });
          const conteosArray = Object.entries(countByMarca).map(([marca, cantidad]) => ({
            label: marca,
            data: cantidad
          }))
          conteosArray.forEach(conteo => {
            this.dataChart.push({id:conteo.label,nested: conteo.data});
          });
          console.log(this.dataChart);
          this.isLoading=false;
        })
      },
      fetchInstalls(){
        let self=this;
        let id=localStorage.getItem('AccountId'); 
        fetch(this.$EndPoint+'instalaciones/get_by_owner/'+id)
        .then(response=>response.json())
        .then(result=>{
          console.log(result);
          this.installs=result;
          result.forEach(function(row){
            if(row.Estado__c!='Instalada'){
              self.installsP.push(row);
            }
          })
        })
      },
      goTo(value){
        this.$router.push('/'+value);
      }
    },
    created(){
      if(localStorage.getItem('IsLoggedIn')=='true'){
        this.fetchContracts();
        this.fetchInstalls();
      }else{
        this.$router.push('/signin')
      }
    }
  };
  </script>
  